import React from 'react'
import './footer.css';

/* Contains support email for volunteers and organizations */
const Footer = () => {
  return (
    <section id="footer">
      <text>For technical issues: contacteconet2023@gmail.com</text>
    </section>
  )
}

export default Footer
